import React from 'react';

import Tables from './Tables.jsx';

const Body = (props) => {
    return (
        <div className="row">
            <Tables data={props.data} />
        </div>
    );
}

export default Body;